import { email } from "@common/schema/user/fields";
import { orgId, domainId, domain } from "@common/schema/organization/fields";

export const roles = {
  label: "Roles",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};

export const status = {
  label: "Status",
  type: "string",
  "minLength": 1
};

export {
  orgId, email, domainId, domain
}